var t = "_icon_1q1xv_1",
    o = "_button_1j9u0_3",
    n = "_buttonWithIcon_1j9u0_31",
    c = {
  icon: t,
  button: o,
  buttonWithIcon: n
};
export { o as button, n as buttonWithIcon, c as default, t as icon };